import { r as registerInstance, a as getAssetPath, h, H as Host } from './index-61cbb87e.js';

const bhIllustrationCss = ".only-on-dark {\n\tdisplay: none;\n}\n\n.only-on-light {\n\tdisplay: none;\n}\n\n[data-theme=\"dark\"] {\n\t.only-on-dark {\n\t\tdisplay: block;\n\t}\n\n\t.only-on-light {\n\t\tdisplay: none;\n\t}\n}\n\n[data-theme=\"light\"] {\n\t.only-on-dark {\n\t\tdisplay: none;\n\t}\n\n\t.only-on-light {\n\t\tdisplay: block;\n\t}\n}\n.bh-illustration {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\talign-self: center;\n\tmax-width: 240px;\n}\n\n.bh-illustration--image {\n\tmargin-bottom: var(--spacing-margin-medium);\n\tmax-width: 220px;\n}\n\n.bh-illustration--title {\n\ttext-align: center;\n\tcolor: var(--color-text-common-primary);\n\tmargin-bottom: 4px;\n}\n\n.bh-illustration--description {\n\ttext-align: center;\n\tcolor: var(--color-text-common-secondary);\n}\n\n";
const BhIllustrationStyle0 = bhIllustrationCss;

const BhIllustration = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.imgSrc = '';
        this.darkImageSrc = '';
        this.source = undefined;
        this.title = undefined;
        this.description = undefined;
        this.htmlDescription = false;
    }
    setImgSrc() {
        this.setImage();
    }
    setImage() {
        const hasSpecialCharacters = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g;
        this.imgSrc = !hasSpecialCharacters.test(this.source)
            ? getAssetPath(`./assets/${this.source}.svg`)
            : getAssetPath(this.source);
        this.darkImageSrc = !hasSpecialCharacters.test(this.source)
            ? getAssetPath(`./assets/${this.source + 'Dark'}.svg`)
            : getAssetPath(this.source);
    }
    componentWillLoad() {
        this.setImage();
    }
    render() {
        if (document.body.getAttribute("data-theme") === null) {
            document.body.setAttribute("data-theme", "light");
        }
        return (h(Host, { key: '426ba22897444d97637289aa80c3db8a4e4ef0f8', class: "bh-illustration" }, h("img", { key: 'c619f4a77a2551ac2ad8829e065c8cbd1a053c37', class: "bh-illustration--image only-on-dark", src: this.darkImageSrc }), h("img", { key: 'c75ab0da4692ff4a48f31da8430d4918b1b212ac', class: "bh-illustration--image only-on-light", src: this.imgSrc }), h("span", { key: 'b799dd8eb9d135847a26bf93bf897a7abb9c0874', class: "typography--subtitle-medium bh-illustration--title" }, this.title), !this.htmlDescription && h("span", { class: "typography--body-small bh-illustration--description" }, this.description), this.htmlDescription && h("slot", { name: "illustration-description" })));
    }
    static get assetsDirs() { return ["assets"]; }
    static get watchers() { return {
        "source": ["setImgSrc"]
    }; }
};
BhIllustration.style = BhIllustrationStyle0;

export { BhIllustration as bh_illustration };

